var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isDianpingAppOrWebview } from '@nibfe/mkt-env-api';
// 通用请求函数
function request(url, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(url, Object.assign({ method: 'GET', headers: {
                    'Content-Type': 'application/json'
                } }, options));
            return yield response.json();
        }
        catch (error) {
            throw error;
        }
    });
}
// 城市数据接口
const CITY_DATA_API = 'https://yapi.sankuai.com/mock/40182/city-data';
// 城市数据缓存
let cityCache = null;
// 城市匹配函数
function matchCity(city, searchName) {
    var _a, _b;
    if (!city)
        return false;
    const name = ((_a = city.name) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) || '';
    const pinyin = ((_b = city.pinyin) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase()) || '';
    // 精确匹配城市名称或拼音，或包含匹配
    return name === searchName || pinyin === searchName || name.includes(searchName) || pinyin.includes(searchName);
}
// 获取城市数据（带缓存）
function getCityData() {
    return __awaiter(this, void 0, void 0, function* () {
        // 如果有缓存就直接返回
        if (cityCache) {
            return cityCache;
        }
        try {
            const result = yield request(CITY_DATA_API);
            let cityList = {
                mt: [],
                dp: []
            };
            if (result === null || result === void 0 ? void 0 : result.data) {
                cityList = result.data;
            }
            else if ((result === null || result === void 0 ? void 0 : result.mt) && (result === null || result === void 0 ? void 0 : result.dp)) {
                cityList = result;
            }
            else {
                return null;
            }
            // 缓存数据
            cityCache = cityList;
            return cityList;
        }
        catch (error) {
            return null;
        }
    });
}
// 根据城市名称获取城市ID
export function getCityIdByName(cityName) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const cityList = yield getCityData();
            if (!cityList) {
                return null;
            }
            const { mt = [], dp = [] } = cityList;
            if (mt.length === 0 && dp.length === 0) {
                return null;
            }
            const searchName = cityName.trim().toLowerCase();
            const isDP = isDianpingAppOrWebview();
            if (isDP) {
                // 点评环境：只在dp数组中查找
                const dpCity = dp.find((city) => matchCity(city, searchName));
                if (dpCity) {
                    return Number(dpCity.id);
                }
            }
            else {
                // 美团环境：只在mt数组中查找
                const mtCity = mt.find((city) => matchCity(city, searchName));
                if (mtCity) {
                    return Number(mtCity.id);
                }
            }
            return null;
        }
        catch (error) {
            return null;
        }
    });
}
